import { CarePathIcon, CollectionItem } from '@ksyos/design-system';
import type { EpisodeCategory } from '../../../../../common/enums/episodeCategory';
import { episodeCategoryIconName } from '../../../elements/Icons/episodeCategoryIconName';

interface IOrganizationActiveCarePathDetailsCollectionItemProps {
    episodeCategory: EpisodeCategory;
    subtitle: string;
    title: string;
}

export function OrganizationActiveCarePathDetailsCollectionItem(
    props: IOrganizationActiveCarePathDetailsCollectionItemProps
) {
    return (
        <CollectionItem
            mediaItem={
                <CarePathIcon
                    icon={episodeCategoryIconName(props.episodeCategory)}
                    size={48}
                    variant="large-multicolor"
                />
            }
            subtitle={props.subtitle}
            title={props.title}
        />
    );
}
